var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer, Popup, PopupMessage } from "../../ExternalDependencies";
const getPopupConfig = (params) => ({
    className: "forgot-pass-popup-success-callback",
    isInIframe: false,
    hasOverlay: false,
    hasCloseBtn: true,
    beforeHideCallback: params.onClose
});
const getPopupMessageConfig = (params) => ({
    actions: {
        close: {
            text: params.closeText,
            onClick: params.onClose
        }
    },
    header: params.header,
    body: params.body
});
let SuccessPopup = class SuccessPopup extends React.PureComponent {
    render() {
        return (React.createElement(Popup, { config: getPopupConfig(this.props) },
            React.createElement(PopupMessage, { config: getPopupMessageConfig(this.props) })));
    }
};
SuccessPopup = __decorate([
    observer
], SuccessPopup);
export { SuccessPopup };
//# sourceMappingURL=SuccessPopup.js.map